import React from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile } from '@pascal/pascal-core';
import { userSettingsStore } from '@pascal/pascal-core/shared/core/store/userSettingsStore';
import { cardsStore } from '../../store/cardsStore';
import { BLACK_JACK_POINT, CARDS_TYPE, UNKNOWN_CARD_TYPE } from '../../enums/cardTypes';
import { gameStore } from '../../store/gameStore';
import { CardBackSideMap } from '../../enums/cardStatus';
import bj from '../../assets/images/png-icons/bj.png';
import bust from '../../assets/images/png-icons/star-black.png';

const DealerCardsSection = observer(() => {
  const {
    dealerCardsInfo: { cards, point, secondPoint, hasBlackJack },
    selectedCardBackSideType,
    selectedCardType,
  } = cardsStore;
  const { toggleInsuranceAnimatedCard } = gameStore;
  const { isAnimationOn } = userSettingsStore;
  const isOnMobile = isMobile();

  if (!cards) return null;

  const selectedDeck = CardBackSideMap[selectedCardBackSideType] || 'deck-1';

  return (
    <div className={`${isOnMobile ? 'm-' : ''}card-dealer-panel`}>
      {cards.map(({ card, index }) => (
        <div
          key={index}
          className={`${isOnMobile ? 'm-' : ''}dealer-card-wrapper ${
            toggleInsuranceAnimatedCard && card === UNKNOWN_CARD_TYPE ? 'peep' : ''
          }
           ${selectedDeck}
           ${isAnimationOn ? 'to-dealer-anim' : 'no-animation'}`}
        >
          <div
            className={`${isOnMobile ? 'm-' : ''}blackjack-card ${
              card === UNKNOWN_CARD_TYPE ? '' : 'card-open'
            }`}
          >
            <div
              className={`${isOnMobile ? 'm-' : ''}blackjack-card-front-side ${selectedCardType} ${
                CARDS_TYPE[card]
              }`}
            />
            <div
              className={`${
                isOnMobile ? 'm-' : ''
              }blackjack-card-back-side ${selectedCardBackSideType}`}
            />
          </div>
        </div>
      ))}
      {(hasBlackJack || point > BLACK_JACK_POINT) && (
        <p className={`${isOnMobile ? 'm-' : ''}dealer-img-block`}>
          {hasBlackJack ? <img src={bj} alt='black_jack' /> : <img src={bust} alt='black_jack' />}
        </p>
      )}
      {!hasBlackJack && point <= BLACK_JACK_POINT && (
        <p className={`${isOnMobile ? 'm-' : ''}counter-num-block dealer`}>
          <span className={`${isOnMobile ? 'm-' : ''}counter-num-block-txt`}>
            {point}
            {secondPoint ? `/${secondPoint}` : ''}
          </span>
        </p>
      )}
    </div>
  );
});

export default DealerCardsSection;
